<template>
  <div class="md-layout" style="width: 500px; max-width: 100%;">
    <div class="md-layout-item md-size-100">
      <md-card style="margin-top:0">
        <md-card-content>
          <div class="md-layout">
            <label class="md-layout-item md-size-25 md-form-label">
              Erstellt
            </label>
            <div class="md-layout-item">
              <md-field class="md-invalid">
                <md-input
                  :value="toGermanDate(task.created_at) + ' von ' + authorName"
                  disabled
                  type="text"
                ></md-input>
              </md-field>
            </div>
          </div>
          <div class="md-layout">
            <label class="md-layout-item md-size-25 md-form-label">
              Beschreibung
            </label>
            <div class="md-layout-item">
              <md-field class="md-invalid">
                <md-input v-model="task.description" type="text"></md-input>
                <validation-error :errors="apiValidationErrors.description" />
              </md-field>
            </div>
          </div>
          <div class="md-layout">
            <label class="md-layout-item md-size-25 md-form-label">
              Zuordnung
            </label>
            <div class="md-layout-item">
              <md-field class="md-invalid">
                <md-select v-model="task.assignee_id">
                  <md-option :value="0"> - Keine Zuordnung - </md-option>
                  <md-option
                    :value="user.id"
                    v-for="user in users"
                    :key="user.id"
                    >{{ user.given_name }} {{ user.family_name }}
                  </md-option>
                </md-select>
                <validation-error :errors="apiValidationErrors.assignee_id" />
              </md-field>
            </div>
          </div>

          <div class="md-layout">
            <label class="md-layout-item md-size-25 md-form-label">
              Zieldatum
            </label>
            <div class="md-layout-item">
              <div style="display: flex; align-items: center;flex-wrap: wrap;">
                <div>
                  <md-datepicker
                    @md-clear="task.target_date = null"
                    @input="e => (task.target_date = toIsoDate(e))"
                    :value="toGermanDate(task.target_date)"
                  />
                </div>
              </div>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";

export default {
  components: { ValidationError },

  mixins: [formMixin],

  props: {
    value: {
      type: Object,
      default() {
        return {};
      }
    }
  },

  data: () => ({
    saving: false,
    task: {}
  }),

  created() {
    this.task = this.value;
  },
  computed: {
    users() {
      return this.$store.getters["users/list"];
    },
    user() {
      return this.$store.getters["profile/me"];
    },
    authorName() {
      const user = this.task.autor || this.user;
      return user ? user.given_name + " " + user.family_name : "";
    }
  },
  methods: {
    async save() {
      this.setApiValidation([]);
      if (!this.task.assignee_id) {
        this.task.assignee_id = null;
      }
      if (!this.task.target_date) {
        this.task.target_date = null;
      }
      // Create if doesnt exist yet
      if (!this.task.id) {
        try {
          await this.$store.dispatch("alerts/success", "Aufgabe angelegt.");
          await this.$store.dispatch("tasks/add", this.task);
        } catch (e) {
          await this.$store.dispatch(
            "alerts/error",
            "Ein Fehler ist aufgetreten!"
          );
          this.setApiValidation(e.response.data.errors);
          return;
        }
      } else {
        try {
          await this.$store.dispatch("tasks/update", this.task);
          await this.$store.dispatch("alerts/success", "Aufgabe aktualisiert.");
        } catch (e) {
          await this.$store.dispatch(
            "alerts/error",
            "Ein Fehler ist aufgetreten!"
          );
          this.setApiValidation(e.response.data.errors);
        }
      }
      this.$emit("saved");
    }
  }
};
</script>
